/* ALLUP DS v1.2 — c-slideshow.js
   brand モード (peek carousel) で初期スクロール位置を中央にする。
   scroll-snap の特性で、scrollLeft 中央セット後に近傍 snap-stop に吸着する。
*/
(function () {
  function centerStart(slider) {
    if (!slider) return;
    var target = (slider.scrollWidth - slider.clientWidth) / 2;
    slider.scrollLeft = target;
  }

  function init() {
    document
      .querySelectorAll('.c-slideshow--peek .slider.slider--everywhere')
      .forEach(centerStart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
